import { useState } from 'react';
import { useAddAddisReport, useRefreshReports } from '@app/sdk';

const reasons: any[] = [
  { code: '1', name: 'Instruction Cancelled' },
  { code: '2', name: 'Payer deceased' },
  { code: '3', name: 'Account transferred' },
  { code: '5', name: 'No Account' },
  { code: '6', name: 'No Instruction' },
  { code: 'B', name: 'Account Closed' },
  { code: 'C', name: 'Account transferred to a different account/branch of the bank/building society' },
  { code: 'F', name: 'Invalid account type' },
  { code: 'G', name: 'Bank will not accept Direct Debits on account' },
  { code: 'H', name: 'Instruction expired' },
  { code: 'I', name: 'Payer reference not unique' },
  { code: 'K', name: 'Instruction cancelled by bank' },
  { code: '7', name: 'DDI Amount not zero' },
  { code: 'L', name: 'Incorrect payer�s account details' },
  { code: 'M', name: 'Transaction code/user status incompatible' },
  { code: 'N', name: 'Transaction disallowed at payers branch' },
  { code: 'O', name: 'Invalid Reference' },
  { code: 'P', name: "Payer's name not present" },
  { code: 'Q', name: 'Originator�s name blank' },
];

export function Auddis(props: {
  accountNumber: string;
  customerName: string;
  sortCode: string;
  bankAccountNumber: string;
  serviceUserNumber: string;
}) {
  const [reasonCode, setReasonCode] = useState(undefined as string);

  const { mutateAsync: addAuddisReport, isPending: submitting } = useAddAddisReport();
  const refreshReports = useRefreshReports();

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addAuddisReport({
      reasonCode: reasonCode,
      accountNumber: props.accountNumber,
      customerName: props.customerName,
      sortCode: props.sortCode,
      bankAccountNumber: props.bankAccountNumber,
      serviceUserNumber: props.serviceUserNumber
    });
    setTimeout(() => {
      refreshReports();
    }, 100);
  };

  return (
    <>
      <section>
        <form className="ui card" onSubmit={(e) => handleSubmit(e)}>
          <div className="content">
            <div className="ui form">
              <div className="field">
                <label>Reason</label>
                <select onChange={(e) => setReasonCode(e.target.value)} value={reasonCode}>
                  <option>--Select a reason--</option>
                  {reasons.map((r) => (
                    <option key={r.code} value={r.code}>
                      {r.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <button className={`ui button ${submitting && 'loading'}`} type="submit" disabled={!reasonCode}>
            <span>Add</span>
          </button>
        </form>
      </section>
    </>
  );
}
